export enum GlobalsBaseControllerType {
	GEOMETRY = 'geometry',
	TEXTURE = 'texture',
}
